import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import IndexPage from './pages/IndexPage';
import RechargePage from './pages/RechargePage';
import RechargeConfirmPage from './pages/RechargeConfirmPage';
import RechargeQRPage from './pages/RechargeQRPage';
import RechargeHistoryPage from './pages/RechargeHistoryPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailedPage from './pages/PaymentFailedPage';
import PaymentTimeoutPage from './pages/PaymentTimeoutPage';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import WechatCallbackPage from './pages/WechatCallbackPage';
import { SystemLoginProvider } from './contexts/SystemLoginContext';
import ProtectedRoute from './components/ProtectedRoute';
import './i18n';

function App() {
  return (
    <SystemLoginProvider>
      <Router>
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route 
            path="/recharge" 
            element={
              <ProtectedRoute>
                <RechargePage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/recharge-confirm" 
            element={
              <ProtectedRoute>
                <RechargeConfirmPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/recharge-qr" 
            element={
              <ProtectedRoute>
                <RechargeQRPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/recharge-history" 
            element={
              <ProtectedRoute>
                <RechargeHistoryPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/payment-success" 
            element={
              <ProtectedRoute>
                <PaymentSuccessPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/payment-failed" 
            element={
              <ProtectedRoute>
                <PaymentFailedPage />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/payment-timeout" 
            element={
              <ProtectedRoute>
                <PaymentTimeoutPage />
              </ProtectedRoute>
            } 
          />
          <Route path="/login" element={<LoginPage />} />
          <Route 
            path="/profile" 
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            } 
          />
          <Route path="/wechat-callback" element={<WechatCallbackPage />} />
          <Route path="*" element={<IndexPage />} />
        </Routes>
        <Toaster 
          position="top-center"
          toastOptions={{
            duration: 2000,
            style: {
              background: '#333',
              color: '#fff',
            },
          }}
        />
      </Router>
    </SystemLoginProvider>
  );
}

export default App;
